module.exports = __webpack_public_path__ + "img/sleeve_cap.6b130950.png";